import { useTranslations } from 'next-intl'

import {
  MasterContractStatus,
  TContractActionType,
  ZContractActionType,
} from '../model/schema'

export const useContractStatusDisplayText = () => {
  const t = useTranslations('guest_lease_list.status')

  const STATUS_MAP = {
    [MasterContractStatus.REVIEWING]: t('lease_pending'),
    [MasterContractStatus.READY]: t('movein_waiting'),
    [MasterContractStatus.ACTIVE]: t('staying'),
    [MasterContractStatus.TERMINATING]: t('moving_out'),
    [MasterContractStatus.CLOSED]: t('lease_ended'),
    [MasterContractStatus.CANCELED]: t('cancelled'),
    [MasterContractStatus.PAYMENT_CANCELED]: t('payment_cancelled'),
  }

  return {
    STATUS_MAP,
  }
}

export const masterContractStatusDisplayText: Record<
  MasterContractStatus,
  string
> = {
  [MasterContractStatus.REVIEWING]: '계약대기',
  [MasterContractStatus.READY]: '입주대기',
  [MasterContractStatus.ACTIVE]: '거주중',
  [MasterContractStatus.TERMINATING]: '퇴실중',
  [MasterContractStatus.CLOSED]: '계약종료',
  [MasterContractStatus.CANCELED]: '취소',
  [MasterContractStatus.PAYMENT_CANCELED]: '결제취소',
}

export const actionTypeDisplayText: Record<TContractActionType, string> = {
  [ZContractActionType.Enum.WAITING_APPROVAL]: '승인대기',
  [ZContractActionType.Enum.WAITING_CHECKIN]: '입주예정',
  [ZContractActionType.Enum.WAITING_CHECKOUT]: '퇴실예정',
  [ZContractActionType.Enum.WAITING_CHECK_FINISH]: '퇴실점검',
}

export const actionTypeTooltipText: Record<TContractActionType, string> = {
  [ZContractActionType.Enum.WAITING_APPROVAL]:
    '임대인의 승인을\n기다리는 계약입니다',
  [ZContractActionType.Enum.WAITING_CHECKIN]:
    '계약 확정 후부터\n입주 확인 전까지의 계약입니다',
  [ZContractActionType.Enum.WAITING_CHECKOUT]:
    '퇴실일 3일 전부터\n전날까지의 계약입니다',
  [ZContractActionType.Enum.WAITING_CHECK_FINISH]:
    '퇴실일 도래 또는 중도 퇴실 후,\n퇴실 점검을 기다리는 계약입니다',
}

export const useContractNotice = ({
  isExtend,
}: { isExtend?: boolean } = {}) => {
  const t = useTranslations()

  if (isExtend) {
    return [
      t('guest_lease_list.dialog.extend_contract.notice.no_fee'),
      t('guest_lease_list.dialog.extend_contract.notice.recontract'),
    ]
  }

  return [
    t('date_selection.notice_description_line1'),
    t('date_selection.notice_description_line2'),
  ]
}
